const inputGroupWrapperCls = "_275ihohr1z";
const labelCls = "_275l1fw6009";
const circleCls = "_275c11n1gdz";

export { circleCls, inputGroupWrapperCls, labelCls };
import "./atom.gender-input.style.linaria.module.css";
//# sourceMappingURL=atom.gender-input.style.js.map
